export default (t) => [
  {
    text: t('Image'),
    value: 'image',
    sortable: false,
    fixed: false,
    width: 70,
    togglable: true
  },
  {
    text: t('Name'),
    value: 'name',
    sortable: true,
    fixed: false,
    togglable: true
  },
  {
    text: t('SKU'),
    value: 'code',
    sortable: false,
    fixed: false,
    width: 200,
    togglable: true
  },
  {
    text: t('Type'),
    value: 'type',
    sortable: true,
    fixed: false,
    width: 100,
    togglable: true
  },
  {
    text: t('Category'),
    value: 'category',
    sortable: true,
    fixed: false,
    width: 100,
    togglable: true
  },
  {
    text: t('Price'),
    value: 'price',
    sortable: false,
    width: 125,
    togglable: true
  },
  {
    text: t('Out of stock at'),
    value: 'out_of_stock_branches',
    sortable: false,
    fixed: false,
    width: 200,
    togglable: true
  },
  {
    text: t('Disabled at'),
    value: 'inactive_branches',
    sortable: false,
    fixed: false,
    width: 200,
    togglable: true
  },
  {
    text: t('Created At'),
    value: 'created_at',
    sortable: true,
    width: 150,
    togglable: true
  },
  {
    text: t('Create By'),
    value: 'created_by',
    sortable: false,
    width: 100,
    togglable: true
  },
  {
    text: t('Action'),
    value: 'action',
    sortable: false,
    width: 150
  },
];
